// @ts-nocheck
import * as Types from "../../../../../../types/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type WebhookSigningKeySecretQueryVariables = Types.Exact<{
  webhookSigningKeyId: Types.Scalars["ID"]["input"];
}>;

export type WebhookSigningKeySecretQuery = {
  __typename?: "GraphqlQuery";
  getWebhookSigningKey: {
    __typename?: "WebhookSigningKey";
    id: string;
    secret: string;
  };
};

export const WebhookSigningKeySecretDocument = gql`
  query WebhookSigningKeySecret($webhookSigningKeyId: ID!) {
    getWebhookSigningKey(webhookSigningKeyId: $webhookSigningKeyId) {
      id
      secret
    }
  }
`;

/**
 * __useWebhookSigningKeySecretQuery__
 *
 * To run a query within a React component, call `useWebhookSigningKeySecretQuery` and pass it any options that fit your needs.
 * When your component renders, `useWebhookSigningKeySecretQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWebhookSigningKeySecretQuery({
 *   variables: {
 *      webhookSigningKeyId: // value for 'webhookSigningKeyId'
 *   },
 * });
 */
export function useWebhookSigningKeySecretQuery(
  baseOptions: Apollo.QueryHookOptions<
    WebhookSigningKeySecretQuery,
    WebhookSigningKeySecretQueryVariables
  > &
    (
      | { variables: WebhookSigningKeySecretQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    WebhookSigningKeySecretQuery,
    WebhookSigningKeySecretQueryVariables
  >(WebhookSigningKeySecretDocument, options);
}
export function useWebhookSigningKeySecretLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    WebhookSigningKeySecretQuery,
    WebhookSigningKeySecretQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    WebhookSigningKeySecretQuery,
    WebhookSigningKeySecretQueryVariables
  >(WebhookSigningKeySecretDocument, options);
}
// @ts-ignore
export function useWebhookSigningKeySecretSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    WebhookSigningKeySecretQuery,
    WebhookSigningKeySecretQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  WebhookSigningKeySecretQuery,
  WebhookSigningKeySecretQueryVariables
>;
export function useWebhookSigningKeySecretSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        WebhookSigningKeySecretQuery,
        WebhookSigningKeySecretQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  WebhookSigningKeySecretQuery | undefined,
  WebhookSigningKeySecretQueryVariables
>;
export function useWebhookSigningKeySecretSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        WebhookSigningKeySecretQuery,
        WebhookSigningKeySecretQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    WebhookSigningKeySecretQuery,
    WebhookSigningKeySecretQueryVariables
  >(WebhookSigningKeySecretDocument, options);
}
export type WebhookSigningKeySecretQueryHookResult = ReturnType<
  typeof useWebhookSigningKeySecretQuery
>;
export type WebhookSigningKeySecretLazyQueryHookResult = ReturnType<
  typeof useWebhookSigningKeySecretLazyQuery
>;
export type WebhookSigningKeySecretSuspenseQueryHookResult = ReturnType<
  typeof useWebhookSigningKeySecretSuspenseQuery
>;
export type WebhookSigningKeySecretQueryResult = Apollo.QueryResult<
  WebhookSigningKeySecretQuery,
  WebhookSigningKeySecretQueryVariables
>;
